import { styled } from '../../hooks/theme';

interface DrawerProps {
  width?: number | string;
  active: boolean;
}

export const ContainerHeader = styled.div`
  width: 100%;
  padding-top: 32px;
  padding-bottom: 32px;

  display: flex;
  justify-content: space-between;
`;

export const ContainerDark = styled.div<DrawerProps>`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background: rgba(0, 0, 0);
  opacity: ${props => (props.active ? '0.2' : '0')};

  transition: opacity 0.3s;

  width: ${props => (props.active ? '100%' : '0')};
  height: 100%;
`;

export const Container = styled.div<DrawerProps>`
  z-index: 100;
  position: fixed;
  top: 0;
  right: 0;
  width: ${props => props.width};
  height: 100%;
  padding: 0 32px;
  overflow: hidden;
  transition: right 0.5s;

  right: ${props => (props.active ? '0' : `calc(-${props.width} - 64px)`)};

  background: ${props => props.theme.colors.neutral.grey[0]};

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  animation-direction: normal;
`;

export const CloseDrawerButton = styled.button`
  height: fit-content;
  padding: 0;
  opacity: 1;
  background: none;
  border: none;
  cursor: pointer;

  animation: appear 0.2s;

  img {
    width: 32px;
    transition: filter 0.1s;
  }

  img:hover {
    color: ${props => props.theme.colors.neutral.grey[40]};
    filter: invert(87%) sepia(0%) saturate(0%) hue-rotate(134deg) brightness(81%) contrast(82%);
  }

  @keyframes appear {
    0% {
      opacity: 0;
    }
    70% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const DrawerContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-right: 5px;
`;

export const DrawerHeader = styled.div`
  padding-top: 5px;
  overflow: hidden;
`;

export const DrawerFooter = styled.div`
  bottom: 0;
  width: 100%;
  padding: 32px 0;
`;
